module.exports = __webpack_public_path__ + "9779d9a1/img/product-icon-grey.b248963c.svg";